<template>
    <div class="c-cal-instance__instance-details">
        <time class="c-cal-instance__date" :datetime="admission.datetime">
            {{ dateLabel }}
        </time>

        <div class="c-cal-instance__opening-time" v-if="openingDetails">
            <span class="c-cal-instance__opening-timenumber">{{ openingDetails.status }}</span>
            <span v-if="openingDetails.note">
                {{ openingDetails.note }}
            </span>
        </div>

        <div v-if="isWednesday" class="c-cal-instance__additional-details">
            <p>
                Enjoy free admissions every Wednesday evening from 4-8 pm, presented by <a href="https://our-impact.bmo.com/">BMO</a>. Tickets
                available in person. Pre-registration not required.
            </p>
        </div>
    </div>

    <div class="c-cal-instance__instance-book">
        <div class="c-cal-instance__actions" v-for="instance in admission.instances">
            <span v-if="instance.limited">Limited</span>
            <a :href="instance.url" class="c-btn c-arrow c-btn--book">
                <i class='fa-light fa-ticket' aria-hidden='true'></i>
                {{ instance.booking_button_label }}
            </a>
        </div>
    </div>
</template>

<script>

import moment from 'moment'

export default {
    name: "AdmissionInstances",
    props: {
        admission: {
            required: true,
            type: Object,
        },
        openingTimes: {
            required: true,
            type: Object,
        },
    },
    computed: {
        isWednesday() {
            return Number(moment.utc(this.admission.datetime).format('d')) === 3
        },
        dateLabel() {
            // Monday, January 1, 2024
            return moment.utc(this.admission.datetime).format('dddd, MMMM D, YYYY')
        },
        openingDetails() {
            return this.openingTimes.details(this.admission.datetime)
        }
    },
}
</script>
